import { Component } from '@angular/core';

@Component({
    selector: 'registration-management-page',
    templateUrl: './registration-management-page.component.html',
    styleUrls: ['./registration-management-page.component.css'],
    standalone: false
})
export class RegistrationManagementPageComponent {}
